import "./incentive.scss"
import "./static/unlock.png"
import "./static/snow-history.svg"
import "./static/nine-day.svg"
